import { PayloadAction } from '@reduxjs/toolkit';

import { DesignData, DesignState } from 'editor/src/store/design/types';

const setOriginalDesignDataReducer = (state: DesignState, action: PayloadAction<DesignData | undefined>) => {
  state.originalDesignData = action.payload;
};

export default setOriginalDesignDataReducer;
